var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.$store.getters['user/level2variant'](_vm.model.level)}},[_vm._v(_vm._s(_vm.trans.labels[
            'users.level.' + _vm.model.level
            ]))]),_vm._v(" "),_c('b-badge',{attrs:{"variant":_vm.$store.getters['user/status2variant'](_vm.model.status)}},[_vm._v(_vm._s(_vm.trans.labels[
            'users.status.' + _vm.model.status
            ]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }